import { skipToken, useQuery } from '@apollo/client/react';
import { Col, Row, Space } from 'antd';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { useChatSettings, useCurrentChat } from '@guuru/chat-web';
import { ChatRowWrapper } from '@guuru/react-chat-messages';
import CloseButton from './CloseButton';
import Heading from './Heading';
import GET_CHAT_HEADER from './queries/GetChatExpertHeader';
import RatingButtons from './RatingButtons';
import StyledHeader from './StyledHeader';

const ChatHeader = function ({ showRate = false, chatId = null }) {
  const { loading } = useCurrentChat();
  const theme = useContext(ThemeContext);

  const { data: { chatSettings } = {}, loading: isLoadingSettings } =
    useChatSettings();

  const { data: { chat } = {} } = useQuery(
    GET_CHAT_HEADER,
    chatId && !loading ? { variables: { id: chatId } } : skipToken,
  );

  if (isLoadingSettings || !chatSettings) {
    return null;
  }

  if (!theme.header) {
    return null;
  }

  return (
    <ChatRowWrapper isUser>
      <StyledHeader
        $backgroundImage={chatSettings.chatWidgetHeaderImageUrl}
        justify="space-between"
      >
        <Col flex="100%">
          <Row>
            <Col flex="auto">
              <CloseButton />
            </Col>
            <Col flex="none">
              <Row justify="end">
                <Space orientation="vertical" size={3}>
                  <Row justify="end">
                    {showRate && (
                      <RatingButtons
                        selectedRating={chat?.rating}
                        chatId={chatId}
                      />
                    )}
                  </Row>
                </Space>
              </Row>
            </Col>
          </Row>
        </Col>
        <Heading chat={chat} />
      </StyledHeader>
    </ChatRowWrapper>
  );
};

ChatHeader.propTypes = {
  showRate: PropTypes.bool,
  chatId: PropTypes.string,
};

export default ChatHeader;
